import * as R from 'ramda';
import { CustomError } from '../../../common/errors';

export type ExistingComplianceStoreCheckResult = {
  identityAuthId: string;
  errorCode: string;
};

export default class ComplianceStoreCheckError extends CustomError {
  private complianceCheckResult: ExistingComplianceStoreCheckResult;

  constructor(checkResult: ExistingComplianceStoreCheckResult) {
    super(`Compliance store check failed. errorCode:[${checkResult.errorCode}]`);
    this.complianceCheckResult = checkResult;
  }

  public getComplianceStoreCheckResult(): ExistingComplianceStoreCheckResult {
    return this.complianceCheckResult;
  }
}

export const isComplianceStoreCheckError = (error: Error): boolean => {
  return R.is(ComplianceStoreCheckError, error);
};
